import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Delivery, DeliveryStatus, DeliveryStatusAux } from 'src/app/models/delivery.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import { formatCurrency, formatDate, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
registerLocaleData(localeIt, 'it');

@Component({
  selector: 'app-finance-fees',
  templateUrl: './finance-fees.component.html',
  styleUrls: ['./finance-fees.component.scss']
})
export class FinanceFeesComponent implements OnInit {

  isSuperAdmin: boolean = false;
  financeFeesFilterForm: any;
  deliveryStatus = DeliveryStatus;
  deliveryStatusAux = DeliveryStatusAux;
  order: {};
  limit: number;
  page: number;
  count: number;
  maxPage: number;
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'Delivery.deliveryDate': 'DESC', 'Delivery.fromTime': 'ASC', 'Delivery.toTime': 'ASC' };
  filtered = {};
  today: any;
  deliveries: Delivery[] = [];
  groups: any;
  selectedDeliveries: Delivery[] = [];
  totalValues = {
    totalValoreVendite: 0,
    totalPrezzoPubblico: 0,
    totalConsegnaPrezzo: 0,
    totalFeePercentage: 0,
    totalFeeValue: 0,
    totalFeeValueWithIva: 0,
    totalDeliveryCost: 0,
    totalIva: 0,
    totalPartnerCollectionPrice: 0,
    totalPrimoMargine: 0,
    totalCorrispettivo: 0,
    totalMargineTotale: 0,
    totalPrimoMarginePercentage: 0,
    totalPrezzoPartner: 0,
    totalNettaSenzIva: 0,
    totalCommissioneIncassi: 0,
    totalMarginePercentage: 0,
  };
  flattenedDeliveries: any[] = [];

  filters = {
    valoreVendite: { operator: '=', value: '' },
    prezzoPubblico: { operator: '=', value: '' },
    consegnaPrezzo: { operator: '=', value: '' },
    feeValue: { operator: '=', value: '' },
    feeValueWithIva: { operator: '=', value: '' },
    costoConsegna: { operator: '=', value: '' },
    primoMargine: { operator: '=', value: '' },
    primoMarginePercentage: { operator: '=', value: '' },
    corrispettivo: { operator: '=', value: '' },
    iva: { operator: '=', value: '' },
    commissioneIncassi: { operator: '=', value: '' },
    margineTotale: { operator: '=', value: '' },
    margineTotalePercentage: { operator: '=', value: '' },
    nettaSenzIva: { operator: '=', value: '' },
    incassoPartner: { operator: '=', value: '' },
    prezzoPartner: { operator: '=', value: '' },
  };
  filteredDeliveries: Delivery[] = [];
  vatPercentage = 0.22;

  constructor(
    private commanUsesService: CommanUsesService,
    private deliveryService: DeliveryService,
    private route: ActivatedRoute,
    private authStatusService: AuthStatusService,
    private spinnerService: SpinnerService,
    private router: Router,
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }

  async ngOnInit() {
    try {
      var today = new Date();
      var tmptoday = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2); //DATA CORRENTE
      this.today = tmptoday;
      this.manageFinanceFeesFilterForm();
      await this.filter();
    } catch (error) {
      this.commanUsesService.showSnackBar(`ERROR_${error?.message || 'UNKNOWN_ERROR'}`);
      this.spinnerService.hide();
    }
  }

  manageFinanceFeesFilterForm(){
    this.financeFeesFilterForm = new FormGroup({
      'Delivery.id': new FormControl(''),
      'Delivery.deliveryDate_from': new FormControl(this.today),
      'Delivery.deliveryDate_to': new FormControl(this.today),
      // 'Delivery.deliveryDate_from': new FormControl('2025-06-22'),
      // 'Delivery.deliveryDate_to': new FormControl('2025-06-22'),
      'Delivery.fromTime': new FormControl(''),
      'Delivery.toTime': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'UserExpert.surname': new FormControl(''),
      'Delivery.status': new FormControl(''),
      'Delivery.address': new FormControl(''),
      'Delivery.serviceType': new FormControl(''),
      'Delivery.billable': new FormControl(''),
      'Delivery.payable': new FormControl(''),
      'Delivery.pickUpAddress': new FormControl(''),
      'Delivery.orderId': new FormControl(''),
      'Delivery.pickUpTime': new FormControl(''),
      'Delivery.customFilter': new FormControl(),
      'Delivery.ddtNumber': new FormControl(''),
      'Product.name': new FormControl(''),
      'Product.price': new FormControl(''),
      'Product.price.operator': new FormControl('equal'),
      'ProductCategory.categoryName': new FormControl(''),
      'PartnerService.price.operator': new FormControl('equal'),
      'PartnerService.price': new FormControl(''),
      'Sale.platform': new FormControl(''),
    })
  }

  async resetFilter() {
    this.financeFeesFilterForm = new FormGroup({
      'Delivery.id': new FormControl(''),
      'Delivery.deliveryDate_from': new FormControl(),
      'Delivery.deliveryDate_to': new FormControl(),
      'Delivery.fromTime': new FormControl(''),
      'Delivery.toTime': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'UserExpert.surname': new FormControl(''),
      'Delivery.status': new FormControl(''),
      'Delivery.address': new FormControl(''),
      'Delivery.serviceType': new FormControl(''),
      'Delivery.billable': new FormControl(''),
      'Delivery.payable': new FormControl(''),
      'Delivery.pickUpAddress': new FormControl(''),
      'Delivery.orderId': new FormControl(''),
      'Delivery.pickUpTime': new FormControl(''),
      'Delivery.customFilter': new FormControl(),
      'Delivery.ddtNumber': new FormControl(''),
      'Product.name': new FormControl(''),
      'Product.price.operator': new FormControl('equal'),
      'Product.price': new FormControl(''),
      'ProductCategory.categoryName': new FormControl(''),
      'PartnerService.operator': new FormControl('equal'),
      'PartnerService.price': new FormControl(''),
      'Sale.platform': new FormControl(''),
    });
    await this.filter();
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

  public async navigateOrder(attribute: string | string[]) {
    delete this.order['Delivery.updatedAt'];
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.loadDeliveries();
    });
  }

  navigate(event) {
    this.loadDeliveries(event.limit, event.page, this.order);
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

  async filter() {
    let filterForm = (new FormGroupToObject()).transform(this.financeFeesFilterForm);
    this.filtered = {};

    if (filterForm['Delivery.id'])
      this.filtered['Delivery.id'] = filterForm['Delivery.id'];
    if (filterForm['Delivery.deliveryDate_from'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.deliveryDate_from']] };
    if (filterForm['Delivery.deliveryDate_to'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'lessThan', values: [filterForm['Delivery.deliveryDate_to']] };
    if (filterForm['Delivery.deliveryDate_from'] && filterForm['Delivery.deliveryDate_to'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'between', values: [filterForm['Delivery.deliveryDate_from'], filterForm['Delivery.deliveryDate_to']] };
    if (filterForm['Delivery.fromTime'])
      this.filtered['Delivery.fromTime'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.fromTime']] };
    if (filterForm['Delivery.toTime'])
      this.filtered['Delivery.toTime'] = { operator: 'lessThan', values: [filterForm['Delivery.toTime']] };
    if (filterForm['Partner.businessName'])
      this.filtered['Partner.businessName'] = { operator: 'like', values: [`%${filterForm['Partner.businessName']}%`] };
    if (filterForm['UserExpert.surname'])
      this.filtered['UserExpert.surname'] = { operator: 'like', values: [`%${filterForm['UserExpert.surname']}%`], concat: [{ string: ' ' }, { column: 'UserExpert.name' }] };
    if (filterForm['Delivery.pickUpAddress'])
      this.filtered['Delivery.pickUpAddress'] = { operator: 'like', values: [`%${filterForm['Delivery.pickUpAddress']}%`], concat: [{ string: ' ' }, { column: 'Delivery.partner.address' }] };
    if (filterForm['Delivery.pickUpTime'])
      this.filtered['Delivery.pickUpTime'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.pickUpTime']] };
    if (filterForm['Delivery.status'])
      this.filtered['Delivery.status'] = filterForm['Delivery.status'];
    if (filterForm['Delivery.address'])
      this.filtered['Delivery.address'] = { operator: 'like', values: [`%${filterForm['Delivery.address']}%`]};
    if (filterForm['Delivery.serviceType'])
      this.filtered['Delivery.serviceType'] = { operator: 'like', values: [`%${filterForm['Delivery.serviceType']}%`]};
    if (filterForm['Delivery.billable'])
      this.filtered['Delivery.billable'] = { operator: 'like', values: [`%${filterForm['Delivery.billable']}%`]};
    if (filterForm['Delivery.payable'])
      this.filtered['Delivery.payable'] = { operator: 'like', values: [`%${filterForm['Delivery.payable']}%`]};
    if (filterForm['Product.name'])
      this.filtered['Product.name'] = { operator: 'like', values: [`%${filterForm['Product.name']}%`]};
    if (filterForm['ProductCategory.categoryName'])
      this.filtered['ProductCategory.categoryName'] = { operator: 'like', values: [`%${filterForm['ProductCategory.categoryName']}%`]};
    if (filterForm['Product.price'])
      this.filtered['Product.price'] = { operator: filterForm['Product.price.operator'], values: [filterForm['Product.price']] };
    if (filterForm['PartnerService.price'])
      this.filtered['PartnerService.price'] = { operator: filterForm['PartnerService.price.operator'], values: [filterForm['PartnerService.price']] };
    if (filterForm['Delivery.customFilter'])
      // this.filtered['Delivery.customFilter'] = { operator: 'like', values: [`%${filterForm['Delivery.customFilter']}%`]};
      this.filtered['Delivery.customFilter'] = `%${filterForm['Delivery.customFilter']}%`;
      // this.filtered['Delivery.customFilter'] = filterForm['Delivery.customFilter'];
    if (filterForm['Sale.platform'])
      this.filtered['Sale.platform'] = { operator: 'like', values: filterForm['Sale.platform']};

    let salesType = 'sales';
    this.filtered['Delivery.serviceType'] = { operator: 'like', values: [`%${salesType}%`]};

    if (filterForm['Delivery.ddtNumber']) {
      this.filtered['Delivery.ddtNumber'] = {
        operator: 'like',
        values: [`%${filterForm['Delivery.ddtNumber']}%`]
      };
    }

    if (filterForm['Delivery.orderId']) {
      this.filtered['Delivery.orderId'] = {
        operator: 'like',
        values: [`%${filterForm['Delivery.orderId']}%`]
      };
    } else {
      // this.filtered['Delivery.orderId'] = {
      //   operator: 'notNull',
      //   values: []
      // };
    }

    // this.filtered['Delivery.ddtNumber'] = {
    //   operator: 'like',
    //   values: [`%8374%`]
    // };

    await this.loadDeliveries();
  }

  async loadDeliveries(limit?: number, page?: number, order?: {}) {

    let filterForm = (new FormGroupToObject()).transform(this.financeFeesFilterForm);
    if(filterForm['Delivery.deliveryDate_to'] && filterForm['Delivery.deliveryDate_from']){
      if((this.today != filterForm['Delivery.deliveryDate_from'])){
        this.defaultOrder = { 'Delivery.deliveryDate': 'ASC', 'Delivery.fromTime': 'ASC', 'Delivery.toTime': 'ASC' };
      }
    }
    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;

    this.spinnerService.show();
    let deliveries = await this.deliveryService.getAllFinanceFees(this.page, this.limit, this.order, this.filtered);
    this.deliveries = deliveries.deliveries;
    this.flattenDeliveries();
    /*
    console.log("this.deliveries", this.deliveries);
    console.log("this.flattenedDeliveries", this.flattenedDeliveries);
    this.deliveries.forEach(delivery => {
      if(delivery.deliveryProducts.length > 0){
        delivery.deliveryProducts.forEach(product => {
          console.log("DELIVERY_PRODUCT_QUANTITY", product.quantity);
          if(product?.productVariant) {
              console.log("PRODUCT", product?.product);
              console.log("DELIVERY_ID", delivery.id);
              console.log("PRODUCT_VARIANT", product?.productVariant);
          }
        });
      }
    });
    */
    this.count = deliveries.count;
    this.maxPage = Math.ceil(this.count / this.limit);
    this.generateTotals();
    this.spinnerService.hide();
  }

  flattenDeliveries() {
    const grouped = new Map<number | string, any[]>();
  
    for (const delivery of this.deliveries) {
      /*
      const key = delivery.ddtNumber ?? 'unknown';
      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key)!.push(delivery);
      */

      let raw = delivery.ddtNumber?.toString() ?? "";

      if (/^[DCFB]/i.test(raw)) {
        raw = raw.substring(1);
      }

      const key = raw.replace(/\D/g, ""); 

      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key)!.push(delivery);
    }
  
    this.flattenedDeliveries = [];
  
    for (const [key, group] of grouped) {
      if (group.length > 1) {
        const totalRow = {
          ...group[0],
          isTotalRow: true,
          deliveryCount: group.length,
        };
  
        this.flattenedDeliveries.push(totalRow);
      }
  
      this.flattenedDeliveries.push(...group);
    }
  }

  showServiceDetails(incomingDelivery: any){
    let data = this.deliveries.find((delivery) => incomingDelivery.id == delivery.id);
    let service = data?.partner?.partnerServices.find((item) => item?.service?.id == incomingDelivery.service);
    return service;
  }

  getDeliveryLink(id: number, deluxyDelivery: boolean): any[] {
    let route = ['/consegne', id];
    if (this.groups.includes('admin')){
        route.push('edit');
    }
    return route;
  }

  formatTimeShow(fromTime, toTime){
    let trimmedFromTime = fromTime != null ? fromTime?.slice(0, -3) : '';
    let trimmedToTime = toTime != null ? toTime?.slice(0, -3) : '';
    let time = trimmedFromTime + '-' + trimmedToTime;
    return time;
  }

  isSelected(delivery: any): boolean {
    return this.selectedDeliveries.includes(delivery);
  }

  selectAllDeliveries(): void {
    const allDeliveriesSelected = this.selectedDeliveries.length === this.deliveries.length;
    this.selectedDeliveries = allDeliveriesSelected ? [] : [...this.deliveries];
  }

  toggleSelection(delivery: any): void {
    if (this.isSelected(delivery)) {
      this.selectedDeliveries = this.selectedDeliveries.filter(item => item !== delivery);
    } else {
      this.selectedDeliveries.push(delivery);
    }
  }

  applyDomFilters() {
    this.filteredDeliveries = this.deliveries.filter(delivery => {
      const computed = this.commanFunctionForValues(delivery);

      return this.compare(computed.valoreVendite, this.filters.valoreVendite) &&
             this.compare(computed.prezzoPubblico, this.filters.prezzoPubblico) &&
             this.compare(computed.consegnaPrezzo, this.filters.consegnaPrezzo) &&
             this.compare(computed.feeValue, this.filters.feeValue) &&
             this.compare(computed.feeValueWithIva, this.filters.feeValueWithIva) &&
             this.compare(computed.totalDeliveryCost, this.filters.costoConsegna) &&
             this.compare(computed.primoMargine, this.filters.primoMargine) &&
             this.compare(computed.primoMarginePercentage, this.filters.primoMarginePercentage) &&
             this.compare(computed.corrispettivo, this.filters.corrispettivo) &&
             this.compare(computed.iva, this.filters.iva) &&
             this.compare(computed.commissioneIncassi, this.filters.commissioneIncassi) &&
             this.compare(computed.margineTotale, this.filters.margineTotale) &&
             this.compare(computed.margineTotalePercentage, this.filters.margineTotalePercentage) &&
             this.compare(computed.nettaSenzIva, this.filters.nettaSenzIva) &&
             this.compare(computed.partnerCollectionPrice, this.filters.incassoPartner) &&
             this.compare(computed.prezzoPartner, this.filters.prezzoPartner);
    });
  
    this.flattenedDeliveries = this.flattenFilteredDeliveries(this.filteredDeliveries);
    this.generateTotals(this.filteredDeliveries);
  }
  
  compare(value: any, filter: { operator: string, value: any }): boolean {
    if (!filter.value && filter.value !== 0) return true;
  
    const target = parseFloat(filter.value);
    const val = parseFloat(value);
  
    switch (filter.operator) {
      case '=': return val === target;
      case '>': return val > target;
      case '<': return val < target;
      case '>=': return val >= target;
      case '<=': return val <= target;
      default: return true;
    }
  }
  
  flattenFilteredDeliveries(deliveries: Delivery[]) {
    const grouped = new Map<number | string, any[]>();
  
    for (const delivery of deliveries) {
      const key = delivery.ddtNumber ?? 'unknown';
      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key)!.push(delivery);
    }
  
    const result = [];
  
    for (const [key, group] of grouped) {
      if (group.length > 1) {
        const totalRow = {
          ...group[0],
          isTotalRow: true,
          deliveryCount: group.length
        };
        result.push(totalRow);
      }
      result.push(...group);
    }
  
    return result;
  }

  commanFunctionForValues(delivery: Delivery) {
    let service = delivery?.partner?.partnerServices?.find(
      (service) => service?.service?.id == delivery?.service
    );
    let deliveryProducts       = delivery?.deliveryProducts || [];
    let feePercentageValue     = Number(service?.price) || 0;
    let feeValue               = 0;
    let totalPartnerPrice      = 0;
    let prezzoPartner          = 0;
    let vatPercentage          = this.vatPercentage;
    let feePercentage          = 0.03;

    if (deliveryProducts.length > 0) {
      deliveryProducts.forEach((product, index) => {
        const quantity = Number(product?.quantity) || 1;
        let productPrice = 0;

        if(delivery?.isFlexiblePrice) {
          let data = delivery?.flexiblePrice ? JSON.parse(delivery?.flexiblePrice) : [];
          data = data[index];
          productPrice = data?.product?.flexiblePrice || 0;
        } else {
          if (product?.productVariant) {
            productPrice = Number(product?.productVariant?.variantPrice) || 0;
          } else {
            productPrice = Number(product?.product?.price) || 0;
          }
        }
    
        const productSubtotal = productPrice * quantity;
        prezzoPartner     += productSubtotal;
        feeValue          += productSubtotal * (feePercentageValue / 100);
        totalPartnerPrice += productSubtotal;
      });
    }

    if(!delivery.billable) {
      prezzoPartner = 0;
      feeValue = 0;
      totalPartnerPrice = 0;
    } 
    
    // let valoreVendite          = Number(delivery?.shopifySale?.totalPrice) || 0;
    let valoreVendite          = 0;
    if (delivery?.shopifySale?.totalPrice != null && delivery?.shopifySale?.totalPrice > 0) {
      valoreVendite = Number(delivery.shopifySale.totalPrice);
    } else if (delivery?.shopifySale?.total != null) {
      valoreVendite = Number(delivery.shopifySale.total);
    }
    let feeValueWithIva        = feeValue + (feeValue * vatPercentage);
    let partnerCollectionPrice = totalPartnerPrice - feeValueWithIva;
    let expertSalary           = delivery?.payable ? Number(delivery?.expertSalary) : 0 || 0;
    let valetAdditionalPrice   = delivery?.payable ? Number(delivery?.valetAdditionalPrice) : 0 || 0;
    let totalDeliveryCost      = expertSalary + valetAdditionalPrice;
    let totalLineItemsPrice    = Number(delivery?.shopifySale?.totalLineItemsPrice) || 0;
    /*
    let primoMargine           = (valoreVendite - prezzoPartner) / (1+vatPercentage) + feeValue;
    let primoMarginePercentage = valoreVendite > 0 ? (primoMargine / valoreVendite) * 100 : 0;
    */
    let prezzoPubblico         = totalLineItemsPrice;
    let shopifyLineItems = [];
    const rawLineItems = delivery?.shopifySale?.lineItems;
    if (rawLineItems && typeof rawLineItems === 'string') {
      shopifyLineItems = JSON.parse(rawLineItems);
    }
    // if(shopifyLineItems) {
    //   const totalPrice = shopifyLineItems.reduce((acc, item) => {
    //     return acc + (parseFloat(item?.price) || 0);
    //   }, 0);
    //   console.log('totalPrice: ', totalPrice);
    //   prezzoPubblico           = totalPrice || 0;
    // }
    let consegnaPrezzo         = this.showDeliveryPrice(delivery) || 0;
    let partnerName            = delivery?.partner?.businessName || '---';
    // let corrispettivo          = Number(valoreVendite) - Number(prezzoPubblico) || 0;
    let corrispettivo          = Number(valoreVendite) - Number(prezzoPartner) || 0;
    let iva                    = this.vatPercentage * (corrispettivo === 0 ? 1 : corrispettivo);

    // let primoMargine           = (valoreVendite - prezzoPubblico) + iva + feeValue;
    let primoMargine           = (valoreVendite - prezzoPartner) + feeValue;
    let primoMarginePercentage = valoreVendite > 0 ? (primoMargine / valoreVendite) * 100 : 0;

    let commissioneIncassi     = valoreVendite * feePercentage || 0;
    let margineTotale          = Number(primoMargine) - Number(commissioneIncassi) - Number(totalDeliveryCost) - iva || 0;
    let margineTotalePercentage= valoreVendite > 0 ? (margineTotale / valoreVendite) * 100 : 0;
    let nettaSenzIva           = (primoMargine / valoreVendite) * 100;

    let multipleDeliveriesWithSameDdtNumber = (this.filteredDeliveries?.length > 0 ? this.filteredDeliveries : this.deliveries).filter((item) => item?.ddtNumber == delivery?.ddtNumber);
 
    return {
      valoreVendite,
      prezzoPubblico,
      consegnaPrezzo,
      partnerName,
      feePercentage: feePercentageValue,
      feeValue: feeValue.toFixed(2),
      feeValueWithIva: feeValueWithIva.toFixed(2),
      totalDeliveryCost,
      iva: iva.toFixed(2),
      partnerCollectionPrice: partnerCollectionPrice.toFixed(2),
      primoMargine: primoMargine.toFixed(2),
      corrispettivo: corrispettivo.toFixed(2),
      margineTotale: margineTotale.toFixed(2),
      primoMarginePercentage: primoMarginePercentage.toFixed(2),
      prezzoPartner: prezzoPartner.toFixed(2),
      nettaSenzIva: nettaSenzIva.toFixed(2),
      margineTotalePercentage: margineTotalePercentage.toFixed(2),
      commissioneIncassi: commissioneIncassi.toFixed(2),
      isMultiple: multipleDeliveriesWithSameDdtNumber.length > 1 ? true : false,
    };
  }

  /*
  generateTotals(deliveriesList: Delivery[] = this.deliveries) {
    
    this.totalValues = {
      totalValoreVendite: 0,
      totalPrezzoPubblico: 0,
      totalConsegnaPrezzo: 0,
      totalFeePercentage: 0,
      totalFeeValue: 0,
      totalFeeValueWithIva: 0,
      totalDeliveryCost: 0,
      totalIva: 0,
      totalPartnerCollectionPrice: 0,
      totalPrimoMargine: 0,
      totalCorrispettivo: 0,
      totalMargineTotale: 0,
      totalPrimoMarginePercentage: 0,
      totalPrezzoPartner: 0,
      totalNettaSenzIva: 0,
      totalCommissioneIncassi: 0
    };
  
    deliveriesList.forEach(delivery => {
      const values                                 = this.commanFunctionForValues(delivery);
      this.totalValues.totalValoreVendite          += Number(values?.valoreVendite) || 0;
      this.totalValues.totalPrezzoPubblico         += Number(values?.prezzoPubblico) || 0;
      this.totalValues.totalConsegnaPrezzo         += Number(values?.consegnaPrezzo) || 0;
      this.totalValues.totalFeePercentage          += Number(values?.feePercentage) || 0;
      this.totalValues.totalFeeValue               += Number(values?.feeValue) || 0;
      this.totalValues.totalFeeValueWithIva        += Number(values?.feeValueWithIva) || 0;
      this.totalValues.totalDeliveryCost           += Number(delivery?.expertSalary) + Number(delivery?.valetAdditionalPrice) || 0;
      this.totalValues.totalIva                    += Number(values?.iva) || 0;
      this.totalValues.totalPartnerCollectionPrice += Number(values?.partnerCollectionPrice) || 0;
      this.totalValues.totalPrimoMargine           += Number(values?.primoMargine) || 0;
      this.totalValues.totalCorrispettivo          += Number(values?.corrispettivo) || 0;
      this.totalValues.totalMargineTotale          += Number(values?.margineTotale) || 0;
      this.totalValues.totalPrimoMarginePercentage += Number(values?.primoMarginePercentage) || 0;
      this.totalValues.totalPrezzoPartner          += Number(values?.prezzoPartner) || 0;
      this.totalValues.totalNettaSenzIva           += Number(values?.nettaSenzIva) || 0;
      this.totalValues.totalCommissioneIncassi     += Number(values?.commissioneIncassi) || 0;
    });
  }
  */

  generateTotals(deliveriesList: Delivery[] = this.deliveries) {
    this.totalValues = {
      totalValoreVendite: 0,
      totalPrezzoPubblico: 0,
      totalConsegnaPrezzo: 0,
      totalFeePercentage: 0,
      totalFeeValue: 0,
      totalFeeValueWithIva: 0,
      totalDeliveryCost: 0,
      totalIva: 0,
      totalPartnerCollectionPrice: 0,
      totalPrimoMargine: 0,
      totalCorrispettivo: 0,
      totalMargineTotale: 0,
      totalPrimoMarginePercentage: 0,
      totalPrezzoPartner: 0,
      totalNettaSenzIva: 0,
      totalCommissioneIncassi: 0,
      totalMarginePercentage: 0,
    };

    const groupedByDdt: { [ddt: string]: Delivery[] } = {};

    deliveriesList.forEach(delivery => {
      if (!groupedByDdt[delivery.ddtNumber]) {
        groupedByDdt[delivery.ddtNumber] = [];
      }
      groupedByDdt[delivery.ddtNumber].push(delivery);
    });

    for (const ddt in groupedByDdt) {
      const group = groupedByDdt[ddt];

      if (group.length > 1) {
        // Use showTotalOfParentRow logic (mark one as total row for reuse)
        const dummyTotalRow = { ...group[0], isTotalRow: true };
        const totals = this.showTotalOfParentRow(dummyTotalRow);

        this.totalValues.totalValoreVendite          += totals.parentValoreVendite;
        this.totalValues.totalPrezzoPubblico         += totals.parentPrezzoPubblico;
        this.totalValues.totalConsegnaPrezzo         += totals.parentConsegnaPrezzo;
        this.totalValues.totalFeePercentage          += totals.parentFeePercentage;
        this.totalValues.totalFeeValue               += totals.parentFeeValue;
        this.totalValues.totalFeeValueWithIva        += totals.parentFeeValueWithIva;
        this.totalValues.totalDeliveryCost           += totals.parentDeliveryCost;
        this.totalValues.totalIva                    += totals.parentIva;
        this.totalValues.totalPartnerCollectionPrice += totals.parentPartnerCollectionPrice;
        this.totalValues.totalPrimoMargine           += totals.parentPrimoMargine;
        this.totalValues.totalCorrispettivo          += totals.parentCorrispettivo;
        this.totalValues.totalMargineTotale          += totals.parentMargineTotale;
        this.totalValues.totalPrimoMarginePercentage += totals.parentPrimoMarginePercentage;
        this.totalValues.totalPrezzoPartner          += totals.parentPrezzoPartner;
        this.totalValues.totalNettaSenzIva           += totals.parentNettaSenzIva;
        this.totalValues.totalCommissioneIncassi     += totals.parentCommissioneIncassi;

      } else {
        // Use existing single delivery logic
        const delivery = group[0];
        const values = this.commanFunctionForValues(delivery);

        this.totalValues.totalValoreVendite          += Number(values?.valoreVendite) || 0;
        this.totalValues.totalPrezzoPubblico         += Number(values?.prezzoPubblico) || 0;
        this.totalValues.totalConsegnaPrezzo         += Number(values?.consegnaPrezzo) || 0;
        this.totalValues.totalFeePercentage          += Number(values?.feePercentage) || 0;
        this.totalValues.totalFeeValue               += Number(values?.feeValue) || 0;
        this.totalValues.totalFeeValueWithIva        += Number(values?.feeValueWithIva) || 0;
        this.totalValues.totalDeliveryCost           += Number(delivery?.expertSalary) + Number(delivery?.valetAdditionalPrice) || 0;
        this.totalValues.totalIva                    += Number(values?.iva) || 0;
        this.totalValues.totalPartnerCollectionPrice += Number(values?.partnerCollectionPrice) || 0;
        this.totalValues.totalPrimoMargine           += Number(values?.primoMargine) || 0;
        this.totalValues.totalCorrispettivo          += Number(values?.corrispettivo) || 0;
        this.totalValues.totalMargineTotale          += Number(values?.margineTotale) || 0;
        this.totalValues.totalPrimoMarginePercentage += Number(values?.primoMarginePercentage) || 0;
        this.totalValues.totalPrezzoPartner          += Number(values?.prezzoPartner) || 0;
        this.totalValues.totalNettaSenzIva           += Number(values?.nettaSenzIva) || 0;
        this.totalValues.totalCommissioneIncassi     += Number(values?.commissioneIncassi) || 0;
      }
    }

    this.totalValues.totalMarginePercentage = Number((Number(this.totalValues?.totalMargineTotale) / Number(this.totalValues.totalValoreVendite)) * 100);

  }


  showDeliveryPrice(delivery: Delivery) {

    if(delivery?.shopifySale?.totalShippingAmount && delivery?.shopifySale?.totalShippingAmount > 0) {
      return Number(delivery?.shopifySale?.totalShippingAmount) || 0;
    }
    if(delivery?.shopifySale?.totalShippingPriceSet){
      let shippingPriceSet = JSON.parse(delivery?.shopifySale?.totalShippingPriceSet);
      return Number(shippingPriceSet?.shop_money?.amount) || 0;
    }
    return 0;
  }

    showTotalOfParentRow(delivery: any) {
      const round2 = (value: any): number => {
        return Number((Number(value) || 0).toFixed(2));
      };

      let totals: any = {
        parentValoreVendite: 0,
        parentPrezzoPubblico: 0,
        parentConsegnaPrezzo: 0,
        parentFeePercentage: 0,
        parentFeeValue: 0,
        parentFeeValueWithIva: 0,
        parentDeliveryCost: 0,
        parentIva: 0,
        parentPartnerCollectionPrice: 0,
        parentPrimoMargine: 0,
        parentCorrispettivo: 0,
        parentMargineparente: 0,
        parentPrimoMarginePercentage: 0,
        parentPrezzoPartner: 0,
        parentNettaSenzIva: 0,
        parentCommissioneIncassi: 0,
        parentMargineTotale: 0,
        parentMargineTotalePercentage: 0
      };

      if (delivery?.isTotalRow) {

        let deliveries = (this.filteredDeliveries?.length > 0 ? this.filteredDeliveries : this.deliveries).filter((item) => item?.ddtNumber == delivery?.ddtNumber);

        deliveries.forEach((item) => {
          const values = this.commanFunctionForValues(item);

          totals.parentValoreVendite += Number(values?.valoreVendite) || 0;
          totals.parentPrezzoPubblico += Number(values?.prezzoPubblico) || 0;
          totals.parentConsegnaPrezzo += Number(values?.consegnaPrezzo) || 0;
          totals.parentFeeValue += Number(values?.feeValue) || 0;
          totals.parentFeeValueWithIva += Number(values?.feeValueWithIva) || 0;
          totals.parentDeliveryCost += Number(values?.totalDeliveryCost) || 0;
          totals.parentPartnerCollectionPrice += Number(values?.partnerCollectionPrice) || 0;
          totals.parentMargineparente += Number(values?.margineTotale) || 0;
          totals.parentPrezzoPartner += Number(values?.prezzoPartner) || 0;
          totals.parentNettaSenzIva += Number(values?.nettaSenzIva) || 0;
          totals.parentPrimoMargine += Number(values?.primoMargine) || 0;
        });

        totals.parentCorrispettivo =
          totals.parentValoreVendite - totals.parentPrezzoPubblico;

        totals.parentIva =
          totals.parentCorrispettivo * this.vatPercentage;

        totals.parentFeePercentage =
          totals.parentPrezzoPubblico > 0
            ? (totals.parentFeeValue / totals.parentPrezzoPubblico) * 100
            : 0;

        totals.parentPrimoMarginePercentage =
          totals.parentValoreVendite > 0
            ? (totals.parentPrimoMargine / totals.parentValoreVendite) * 100
            : 0;

        totals.parentCommissioneIncassi =
          totals.parentValoreVendite * 0.03;

        totals.parentMargineTotale =
          totals.parentPrimoMargine -
          totals.parentCommissioneIncassi -
          totals.parentDeliveryCost -
          totals.parentIva;

        totals.parentMargineTotalePercentage =
          totals.parentValoreVendite > 0
            ? (totals.parentMargineTotale / totals.parentValoreVendite) * 100
            : 0;
      }

      Object.keys(totals).forEach((key) => {
        totals[key] = round2(totals[key]);
      });

      return totals;
    }

  exportFinanceFeeReport() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Finance Report');

    const headers = [
      'STATO', 'ID VENDITA', 'ID CONSEGNE', 'DATA CONSEGNA', 'PRODOTTO', 'CATEGORIA',
      'VALORE VENDITE', 'PREZZO PUBBLICO', 'CONSEGNA PREZZO', 'PARTNER',
      'PREZZO PARTNER', 'FEE %', 'FEE VALUE', 'FEE + IVA',
      'COSTO CONSEGNA', 'PRIMO MARGINE', 'PRIMO MARGINE %',
      'CORRISPETTIVO', 'IVA', 'COMMISSIONE INCASSI', 'MARGINE TOTALE',
      'MARGINE TOTALE %', 'INCASSO PARTNER',
    ];

    worksheet.addRow(headers).eachCell((cell) => {
      cell.font = { bold: true };
    });

    for (const delivery of this.flattenedDeliveries) {

      const euro = (value: number) => formatCurrency(value || 0, 'it', '€', 'EUR', '1.2-2');
      const formatDateIt = (date: any) => formatDate(date, 'fullDate', 'it');
      const values = this.commanFunctionForValues(delivery);
      const parentValues = this.showTotalOfParentRow(delivery);

      const productNames = delivery.deliveryProducts?.map(p => p?.product?.name).filter(Boolean).join(', ') || '';
      const categoryNames = delivery.deliveryProducts?.map(p => p?.product?.productCategory?.categoryName).filter(Boolean).join(', ') || '';
      const priceStrings = delivery.deliveryProducts?.map(p => {
        const quantity = p?.quantity || 1;
        const price = p?.productVariant?.variantPrice || p?.product?.price || 0;
        return `${(price * quantity).toFixed(2)} €`;
      }).join(', ') || '';

      const isTotal = delivery.isTotalRow;
      const isGrouped = values?.isMultiple;
      const margin = Number(values?.margineTotale);

      const rowData = [
        (delivery.status || '').toUpperCase(),
        Number(delivery.ddtNumber),
        Number(delivery.id),
        formatDateIt(delivery.deliveryDate),
        productNames,
        categoryNames,
        euro(Number(isTotal ? parentValues.parentValoreVendite : values?.valoreVendite ?? 0)),
        euro(Number(isTotal ? parentValues.parentPrezzoPubblico : values?.prezzoPubblico ?? 0)),
        euro(Number(isTotal ? parentValues.parentConsegnaPrezzo : values?.consegnaPrezzo ?? 0)),
        delivery.partner?.businessName || '---',
        euro(Number(isTotal ? parentValues.parentPrezzoPartner : values.prezzoPartner ?? 0)),
        Number(isTotal ? parentValues.parentFeePercentage : values?.feePercentage ?? 0) + '%',
        euro(Number(isTotal ? parentValues.parentFeeValue : values?.feeValue ?? 0)),
        euro(Number(isTotal ? parentValues.parentFeeValueWithIva : values?.feeValueWithIva ?? 0)),
        euro(Number(isTotal ? parentValues.parentDeliveryCost : values?.totalDeliveryCost ?? 0)),
        euro(Number(isTotal ? parentValues.parentPrimoMargine : values?.primoMargine ?? 0)),
        Number(isTotal ? parentValues.parentPrimoMarginePercentage : values?.primoMarginePercentage ?? 0) + '%',
        euro(Number(isTotal ? parentValues.parentCorrispettivo : values?.corrispettivo ?? 0)),
        euro(Number(isTotal ? parentValues.parentIva : values?.iva ?? 0)),
        euro(Number(isTotal ? parentValues.parentCommissioneIncassi : values?.commissioneIncassi ?? 0)),
        euro(Number(isTotal ? parentValues.parentMargineTotale : values?.margineTotale ?? 0)),
        Number(isTotal ? parentValues.parentMargineTotalePercentage : values?.margineTotalePercentage ?? 0) + '%',
        euro(Number(isTotal ? parentValues.parentPartnerCollectionPrice : values?.partnerCollectionPrice ?? 0)),
      ];

      const row = worksheet.addRow(rowData);

      let bgColor = null;

      if (margin <= 0) {
        bgColor = 'FFFFCCCC'; // light red background
      } else if (isTotal) {
        bgColor = 'FFd0ebff'; // dark blue
      } else if (isGrouped) {
        bgColor = 'FFe7f5ff'; // light blue
      }

      if (bgColor) {
        row.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: bgColor },
          };
          if (margin <= 0) {
            cell.font = { color: { argb: 'FF000000' }, bold: true }; // black bold text for red rows
          }
        });
      }
    }

    // Auto column widths
    worksheet.columns.forEach((col) => {
      let maxLength = 10;
      col.eachCell({ includeEmpty: true }, (cell) => {
        const value = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, value.length);
      });
      col.width = maxLength + 2;
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileSaver.saveAs(blob, 'corrispettivi.xlsx');
    });
  }

  calculatePartnerPrice(delivery: Delivery): number {
    let prezzoPartner = 0;
    let feeValue = 0;
    let totalPartnerPrice = 0;
    const feePercentageValue = 10;

    if(!delivery?.billable) {
      return 0;
    }
    
    if (delivery?.deliveryProducts && delivery.deliveryProducts.length > 0) {
      delivery.deliveryProducts.forEach((product, index) => {
        const quantity = Number(product?.quantity) || 1;
        let productPrice = 0;
        
        if (delivery?.isFlexiblePrice) {
          let data = delivery?.flexiblePrice ? JSON.parse(delivery?.flexiblePrice) : [];
          data = data[index];
          productPrice = data?.product?.flexiblePrice || 0;
        } else {
          if (product?.productVariant) {
            productPrice = Number(product?.productVariant?.variantPrice) || 0;
          } else {
            productPrice = Number(product?.product?.price) || 0;
          }
        }
        const productSubtotal = productPrice * quantity;
        prezzoPartner += productSubtotal;
      });
    }

    return prezzoPartner;
  }
}
